module.exports = __webpack_public_path__ + "static/media/galerija_2013 (16).8de1db0a.JPG";